var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "DialogBase",
    {
      attrs: {
        visible: _vm.dialogVisible,
        title: "Cập nhật số điện thoại nhận tin nhắn SMS",
        size: "sm",
        width: "550px",
        top: "15vh",
        "close-on-click-modal": false,
        "confirm-loading": _vm.loadingButton,
        "cancel-text": _vm.$t("button.close"),
        "confirm-text": _vm.$t("button.save"),
      },
      on: {
        "update:visible": _vm.handleVisibleUpdate,
        cancel: _vm.closeDialogByButton,
        confirm: _vm.submitForm,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "userData",
          attrs: {
            model: _vm.userData,
            "label-width": "140px",
            "label-position": "left",
            rules: _vm.rules,
          },
        },
        [
          _c("el-form-item", { attrs: { label: "Số điện thoại cũ" } }, [
            _c("span", [_vm._v(_vm._s(_vm.userData.oldPhone))]),
          ]),
          _c(
            "el-form-item",
            { attrs: { label: "Số điện thoại mới", prop: "newPhone" } },
            [
              _c("el-input", {
                attrs: {
                  type: "number",
                  min: "0",
                  max: "0",
                  placeholder: "Nhập Số điện thoại nhận SMS",
                },
                model: {
                  value: _vm.userData.newPhone,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.userData,
                      "newPhone",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "userData.newPhone",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }